export const APISettings = {
    headers: new Headers({
        'Accept': 'application/json'
    }),
    baseURL: window.location.origin+'/wp-json/',
    // baseURL: 'http://localhost:80/wp-json/',
}